import { fireOnce, trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import type { MiniInterviewType } from 'src/packages/polaris/types';

export const trackTreatmentPlanButtonViewed = (args: {
  interviewType: MiniInterviewType;
  conditionName: string;
  interviewToken: string;
  predictorId: number;
}) => {
  const event = {
    action: 'treatment-plan-button-viewed',
    category: getCategory(args.interviewType),
    property: JSON.stringify({
      conditionName: args.conditionName,
      predictorId: args.predictorId,
    }),
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackTreatmentPlanButtonClicked = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  conditionName: string;
  predictorId: number;
}) =>
  trackStructuredEvent({
    action: 'treatment-plan-button-clicked',
    category: getCategory(args.interviewType),
    property: JSON.stringify({
      conditionName: args.conditionName,
      predictorId: args.predictorId,
    }),
    label: args.interviewToken,
  });

export const trackTreatmentPlanViewed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  conditionName: string;
  severity: string;
  predictorId: number;
}) => {
  const event = {
    action: 'treatment-plan-viewed',
    category: getCategory(args.interviewType),
    property: JSON.stringify({
      conditionName: args.conditionName,
      predictorId: args.predictorId,
      severityLevel: args.severity,
    }),
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackTreatmentPlanNotFoundDisplayed = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  conditionName: string;
  severity: string;
  predictorId: number;
}) => {
  const event = {
    action: 'treatment-plan-not-found',
    category: getCategory(args.interviewType),
    property: JSON.stringify({
      conditionName: args.conditionName,
      predictorId: args.predictorId,
      severityLevel: args.severity,
    }),
    label: args.interviewToken,
  };
  fireOnce(() => {
    trackStructuredEvent(event);
  }, `${event.action}-${event.category}-${event.property}-${event.label}`);
};

export const trackUserChangedSeverity = (args: {
  interviewType: MiniInterviewType;
  interviewToken: string;
  conditionName: string;
  severity: string;
  predictorId: number;
}) => {
  trackStructuredEvent({
    action: 'treatment-plan-severity-changed-by-user',
    category: getCategory(args.interviewType),
    property: JSON.stringify({
      conditionName: args.conditionName,
      predictorId: args.predictorId,
      severityLevel: args.severity,
    }),
    label: args.interviewToken,
  });
};
